import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { SearchBaseClass } from "../../helpers/search";

var Unsplash = /*#__PURE__*/function (_SearchBaseClass) {
  _inherits(Unsplash, _SearchBaseClass);

  var _super = _createSuper(Unsplash);

  function Unsplash(apiKey) {
    var _this;

    _classCallCheck(this, Unsplash);

    return _this = _super.call(this, {
      apiKey: apiKey,
      name: "unsplash",
      icon: "<svg aria-hidden=\"true\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M81 113v72h94v-72h81v143H0V113h81zM175 0v71H81V0h94z\" fill=\"#000\" fill-rule=\"evenodd\"/></svg>",
      color: "#333",
      poweredByUrl: "https://unsplash.com",
      popularEndpoint: function popularEndpoint(apiKey) {
        return "https://api.unsplash.com/photos?client_id=".concat(apiKey);
      },
      searchEndpoint: function searchEndpoint(apiKey, query) {
        return "https://api.unsplash.com/search/photos?client_id=".concat(_this.apiKey, "&page=1&query=").concat(encodeURIComponent(query));
      },
      getButton: function getButton(image) {
        return "<div class=\"result\">\n        <button aria-label=\"".concat(image.alt_description || image.description, "\" data-full-url=\"").concat(image.urls.regular, "\" style=\"background-image: url('").concat(image.urls.thumb, "')\"></button>\n        <small class=\"author\">\n          <img alt=\"\" src=\"").concat(image.user.profile_image.small, "\">\n          <span>").concat(image.user.name, "</span>\n        </small>\n      </div>");
      },
      getSearchResults: function getSearchResults(response) {
        return response.results;
      },
      getPopularResults: function getPopularResults(response) {
        return response;
      }
    });
  }

  return Unsplash;
}(SearchBaseClass);

export { Unsplash as default };